import req from './request.js'


export function videoSearch(data) {
  return req('get', '/api/video/lists', data)
}